import type { DraftStorePort } from '../ports/drafts';
import type { PuzzleDraft } from '../editor/draft';
import { DRAFTS_STORE, lazyClientDb } from './indexed-db';

export class IndexedDBDraftStore implements DraftStorePort {
  private readonly getDb = lazyClientDb();

  async listDrafts(): Promise<PuzzleDraft[]> {
    const drafts = (await (await this.getDb()).getAll(DRAFTS_STORE)) as PuzzleDraft[];
    return drafts.sort((a, b) => b.updatedAt - a.updatedAt);
  }

  async getDraft(id: string): Promise<PuzzleDraft | null> {
    return ((await (await this.getDb()).get(DRAFTS_STORE, id)) as PuzzleDraft | undefined) ?? null;
  }

  async saveDraft(draft: PuzzleDraft): Promise<void> {
    await (await this.getDb()).put(DRAFTS_STORE, draft);
  }

  async deleteDraft(id: string): Promise<void> {
    await (await this.getDb()).delete(DRAFTS_STORE, id);
  }
}
